export default "1,Kalvingsland\n2,Oksebeiteland\n"